export { cn } from './cn';

/**
 * Get status color classes for booking statuses
 * @param {string} status - The booking status
 * @returns {string} Tailwind CSS classes for background and text colors
 */
export const getStatusColor = (status) => {
  switch (status) {
    case 'pending':
      return 'bg-amber-50 text-amber-800 border border-amber-200/80 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-800/50';
    case 'confirmed':
      return 'bg-sky-50 text-sky-800 border border-sky-200/80 dark:bg-sky-950/40 dark:text-sky-300 dark:border-sky-800/50';
    case 'in_progress':
      return 'bg-primary-50 text-primary-800 border border-primary-200/80 dark:bg-primary-950/40 dark:text-primary-300 dark:border-primary-800/50';
    case 'completed':
      return 'bg-emerald-50 text-emerald-800 border border-emerald-200/80 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-800/50';
    case 'cancelled':
      return 'bg-red-50 text-red-800 border border-red-200/80 dark:bg-red-950/40 dark:text-red-300 dark:border-red-800/50';
    case 'no_show':
      return 'bg-gray-100 text-gray-700 border border-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600';
    case 'disputed':
      return 'bg-amber-50 text-amber-900 border border-amber-200/80 dark:bg-amber-950/40 dark:text-amber-200 dark:border-amber-800/50';
    case 'refunded':
      return 'bg-gray-100 text-gray-700 border border-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600';
    default:
      return 'bg-gray-100 text-gray-700 border border-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600';
  }
};

/**
 * Format status text with proper capitalization
 * @param {string} status - The booking status
 * @returns {string} Formatted status text
 */
export const formatStatusText = (status) => {
  return status.replace('_', ' ').charAt(0).toUpperCase() + status.replace('_', ' ').slice(1).toLowerCase();
};

// Password validation utilities
export * from './passwordValidation';

// Date and time utilities
export * from './dateUtils';
